// components
import { IconButton, InfoIcon, MuiTooltip } from "@common";
import { INTEGRATION_CODE_SAP_SUCCESS_FACTOR } from "@constants";
const WarningCode = ({ integrationCode, ...props }) => {
    // Add integration Code and the ToolTip You want to Display
    const getTooltipTitle = () => {
        if (integrationCode === INTEGRATION_CODE_SAP_SUCCESS_FACTOR) {
            return "Get Public Certificate (X.509)";
        }
        else {
            return "Get Public Certificate (X.509) for OAuth integration";
        }
    };
    return (
        <MuiTooltip title={getTooltipTitle()}>
            <IconButton  {...props}>
                <InfoIcon sx={{ fontSize: "1.5rem", color: "#00527d" }} />
            </IconButton>
        </MuiTooltip>
    );
};
export default WarningCode;
